var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		4050,
		4050
	],
	"./osmTagToNameMapping-cs.ts": [
		61808,
		1808
	],
	"./osmTagToNameMapping-de.template.ts": [
		39277,
		9277
	],
	"./osmTagToNameMapping-de.ts": [
		25809,
		5809
	],
	"./osmTagToNameMapping-en.ts": [
		85509,
		5509
	],
	"./osmTagToNameMapping-hu.template.ts": [
		13881,
		3881
	],
	"./osmTagToNameMapping-hu.ts": [
		23373,
		3373
	],
	"./osmTagToNameMapping-it.template.ts": [
		11235,
		1235
	],
	"./osmTagToNameMapping-it.ts": [
		79863,
		9863
	],
	"./osmTagToNameMapping-pl.template.ts": [
		95816,
		5816
	],
	"./osmTagToNameMapping-pl.ts": [
		98966,
		8966
	],
	"./osmTagToNameMapping-sk.template.ts": [
		91770,
		1770
	],
	"./osmTagToNameMapping-sk.ts": [
		28408,
		8408
	],
	"./osmTagToNameMapping-xx.template.ts": [
		58948,
		8948
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;